import React from 'react';

/** Shows `current/max` under a text field; highlights when near or at limit. */
export function FieldCharCount({ length, max }: { length: number; max: number }) {
  const nearLimit = length > max * 0.9;
  const atLimit = length >= max;
  return (
    <div
      style={{
        fontSize: 12,
        marginTop: 6,
        textAlign: 'right',
        color: atLimit ? '#FF8300' : nearLimit ? '#B85400' : '#5B7893',
      }}
    >
      {length}/{max}
    </div>
  );
}
